import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import FileSearchBar from "../../components/filePacket/FileSearchBar";
import { AppLayout } from "../../components/layout/Header";
import { emptyFileFilters, filterFileIndex, uniqueAgents } from "../../js/api/filePacket";
import { useFileIndex } from "../../js/hooks/useFilePacket";
import { useDesk } from "../../js/hooks/useDesk";
import { formatDate, prettyValue } from "../../js/utils/formatters";

function stamp(iso) {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${formatDate(iso)} ${date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}`;
}

export default function AgentFiles() {
  const desk = useDesk();
  const { rows } = useFileIndex();
  const [filters, setFilters] = useState(emptyFileFilters);
  const agents = useMemo(() => uniqueAgents(rows), [rows]);
  const visible = useMemo(() => filterFileIndex(rows, filters), [rows, filters]);

  return (
    <AppLayout variant={desk.variant === "broker" ? "broker" : "agent"}>
      <div className="page-header">
        <div>
          <h1>Files</h1>
          <p className="page-lead">
            One searchable File per client — checklist, timeline, messages, calendar, and packet
            PDF. This index opens the File object; it does not replace Messages or Client Manager.
          </p>
        </div>
      </div>

      <div className="card stack">
        <FileSearchBar filters={filters} agents={agents} onChange={setFilters} />
        <p className="muted">
          {visible.length} file{visible.length === 1 ? "" : "s"}
          {visible.length !== rows.length ? ` of ${rows.length}` : ""}
        </p>
      </div>

      <div className="card" style={{ overflowX: "auto", marginTop: "1rem" }}>
        <table className="sort-table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Type</th>
              <th>Status</th>
              <th>Agent</th>
              <th>Updated</th>
              <th>Open</th>
            </tr>
          </thead>
          <tbody>
            {visible.map((row) => (
              <tr key={row.id}>
                <td>
                  <strong>{row.name || "Client"}</strong>
                  <div className="muted">{[row.email, row.phone].filter(Boolean).join(" · ") || "No contact yet"}</div>
                  <div className="muted">{row.address || "No address on file"}</div>
                </td>
                <td>{prettyValue(row.fileType)}</td>
                <td>
                  {row.statusLabel}
                  <div className="muted">Checklist {row.progress}%</div>
                </td>
                <td>{row.agent || "—"}</td>
                <td>{stamp(row.when)}</td>
                <td>
                  <Link to={desk.file(row.id)} className="primary-btn">
                    Open File
                  </Link>
                </td>
              </tr>
            ))}
            {!visible.length ? (
              <tr>
                <td colSpan={6} className="muted">
                  No files match this search. Clear a filter or open Client Manager to add a buyer.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
